import type { IconSvgObject } from './types';

const MoveUpRightIcon: IconSvgObject = [
  ["path", { d: "M18.5781 12C18.5968 10.6865 19.5004 6.33638 18.5781 5.41409C17.6558 4.4918 13.3057 5.39542 11.9922 5.41408", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.46186 18.4697C4.16896 18.7626 4.16896 19.2374 4.46186 19.5303C4.75475 19.8232 5.22962 19.8232 5.52252 19.5303L4.99219 19L4.46186 18.4697ZM18.5225 6.53033C18.8154 6.23744 18.8154 5.76256 18.5225 5.46967C18.2296 5.17678 17.7548 5.17678 17.4619 5.46967L17.9922 6L18.5225 6.53033ZM4.99219 19L5.52252 19.5303L18.5225 6.53033L17.9922 6L17.4619 5.46967L4.46186 18.4697L4.99219 19Z", fill: "currentColor", key: "1" }]
];

export default MoveUpRightIcon;
